<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Basic Salary"
      text="Update Basic Salary"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localBasicSalary.current_cycle_basic_salary" 
                v-money="money"
                label="Basic Salary"
                outlined
                prefix="RM"
              />
            </v-col> 
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update and re-compute
        </v-btn>
      </v-card-actions>
    </material-card>   
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      basicSalary: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localBasicSalary: null,
        loading: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        this.localBasicSalary = { ...this.basicSalary }

        if (this.localBasicSalary.current_cycle_basic_salary) { this.localBasicSalary.current_cycle_basic_salary = (Math.round((this.localBasicSalary.current_cycle_basic_salary / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.computationBasicSalary().update(this.basicSalary.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          current_cycle_basic_salary: this.localBasicSalary.current_cycle_basic_salary.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>
